
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import ReleasePage from "./pages/ReleasePage";
import { AccessProvider } from "./hooks/useAccessControl";
import AccessControl from "./components/AccessControl";
import AdminPanel from "./components/Admin/AdminPanel";
import ClientReleases from "./components/ClientReleases";

const queryClient = new QueryClient();


const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <BrowserRouter>
        <AccessProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/access" element={<AccessControl />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/clients/:clientId" element={<ClientReleases />} />
            <Route path="/clients/:clientId/releases/:releaseId" element={<ReleasePage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AccessProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
